import { DataAOI } from "../types/interfaces";
import { MapPolygon } from "../types/mapInterfaces";

export const createMapPolygonFromDataAOI = (aoi: DataAOI): MapPolygon => {
    return {
        name: aoi.name,
        color: "#0000ff",
        wkt: aoi.webMercatorPolygon
    }
}